<template>
  <v-app>
    <v-content class="white">
      <router-view />
    </v-content>
    <!-- <Footer /> -->
  </v-app>
</template>

<script>
// import Footer from '@/components/Footer'

export default {
  name: 'App',

  components: {
    // Footer,
  },
}
</script>

<style lang="scss">
  section {
    padding: 50px 0;

    .textflow &:not(:first-of-type) {
      padding-top: 0px;
      margin-top: -30px;
    }
  }
  .container {
    max-width: 900px;

    section.slim &, &.slim, .textflow section & {
      max-width: 700px;
    }

    section.wide &, &.wide {
      max-width: 1200px;
    }
  }

  h1 {
    font-size: 28px;
  }
  h2 {
    font-size: 24px;
  }
  h3 {
    font-size: 20px;
  }
  p {
    font-size: 18px;

    &:last-of-type {
      margin-bottom: 0px;
    }
  }

  .v-btn {
    text-transform: none !important;
    box-shadow: none !important;
  }
</style>
